import type { ChatRepository } from '@zetyar/data-contracts'
import { createSupabaseChatRepository } from '@zetyar/supabase-client'
import { getSupabaseClient } from '@/infrastructure/supabase/app'

export const webChatRepository: ChatRepository = createSupabaseChatRepository(getSupabaseClient())
